"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerPathGroup = exports.apiPathGroup = exports.packageGroup = exports.subjectName = void 0;
exports.subjectName = 'Member Permission';
exports.packageGroup = 'member-permission';
exports.apiPathGroup = 'member-permissions';
exports.routerPathGroup = 'member-permission';
